import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ColumnFiltersState, OnChangeFn, PaginationState, SortingState } from '@tanstack/react-table';

interface StoresTableFilteringState {
    sorting: SortingState;
    setSorting: OnChangeFn<SortingState>;
    columnFilters: ColumnFiltersState;
    setColumnFilters: OnChangeFn<ColumnFiltersState>;
    pagination: PaginationState;
    setPagination: OnChangeFn<PaginationState>;
}

export const useStoresTableFilteringStore = create<StoresTableFilteringState>()(
    persist(
        (set) => ({
            sorting: [],
            setSorting: (updaterOrValue) => {
                set((state) => {
                    const newSorting = typeof updaterOrValue === 'function'
                        ? (updaterOrValue as (old: SortingState) => SortingState)(state.sorting)
                        : updaterOrValue;
                    return { sorting: newSorting };
                });
            },
            columnFilters: [],
            setColumnFilters: (updaterOrValue) => {
                set((state) => {
                    const newColumnFilters = typeof updaterOrValue === 'function'
                        ? (updaterOrValue as (old: ColumnFiltersState) => ColumnFiltersState)(state.columnFilters)
                        : updaterOrValue;
                    return { columnFilters: newColumnFilters };
                });
            },
            pagination: {
                pageIndex: 0,
                pageSize: 10,
            },
            setPagination: (updaterOrValue) => {
                set((state) => {
                    const newPagination = typeof updaterOrValue === 'function'
                        ? (updaterOrValue as (old: PaginationState) => PaginationState)(state.pagination)
                        : updaterOrValue;
                    return { pagination: newPagination };
                });
            },
        }),
        {
            name: 'stores-table-filtering-storage',
        }
    )
);
